import styled, { keyframes } from 'styled-components';
import { v2Colors, v2FontFamily } from '../../../../formInputsV2/styles/tokens';

const fadeInSlide = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const crossfade = keyframes`
  0% {
    opacity: 0;
    transform: translateY(4px);
  }
  15% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -160px 0;
  }
  100% {
    background-position: 160px 0;
  }
`;

const glowPulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 4px 1px rgba(0, 166, 81, 0.55);
    transform: translate(50%, -50%) scale(1);
  }
  50% {
    box-shadow: 0 0 10px 3px rgba(0, 166, 81, 0.75);
    transform: translate(50%, -50%) scale(1.25);
  }
`;

export const LambdaLoaderCardStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 14px 18px;
  background: linear-gradient(135deg, rgba(0, 166, 81, 0.14), rgba(0, 166, 81, 0.05));
  border: 1px solid rgba(0, 166, 81, 0.16);
  border-radius: 14px;
  font-family: ${v2FontFamily};
  animation: ${fadeInSlide} 0.4s ease-out;
`;

export const LoaderTopRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
`;

export const LoaderLabel = styled.p`
  margin: 0;
  overflow: hidden;
  color: ${v2Colors.textMuted};
  font-family: ${v2FontFamily};
  font-size: 13.5px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  animation: ${crossfade} 400ms ease-out;
`;

export const ProgressPercent = styled.span`
  flex-shrink: 0;
  font-family: ${v2FontFamily};
  font-size: 22px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  background: linear-gradient(90deg, ${v2Colors.primary}, #22c55e);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const ProgressTrack = styled.div`
  position: relative;
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: ${v2Colors.disabledSurface};
  overflow: visible;
`;

export const ProgressFill = styled.div`
  position: relative;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    ${v2Colors.primary} 0%,
    #34d399 50%,
    ${v2Colors.primary} 100%
  );
  background-size: 200px 100%;
  transition: width 400ms ease-out;
  animation: ${shimmer} 1.2s linear infinite;
`;

export const ProgressHead = styled.span`
  position: absolute;
  top: 50%;
  right: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffffff;
  animation: ${glowPulse} 1.4s ease-in-out infinite;
`;
